import React from 'react';
import './SdgIcon.css';

/* One of the 17 official UN Sustainable Development Goal icons.

   The real artwork, not a stand-in: `data.SDG` holds a name and an order and nothing else, so
   until now a goal could only be drawn as its number in a coloured square. The files live in
   `public/sdg/<n>.png` (the UN's own current set, downscaled — see ATTRIBUTION.txt beside them,
   which also carries the one condition on using them) and are served as ordinary static assets:
   17 files the browser caches once, rather than 17 more rows in every payload.

   ★ Keyed on the goal's official NUMBER, which is the one thing about an SDG that is stable
   everywhere: the file name, the colour, the translated label and the badge inside the artwork
   all agree on it. A number outside 1..17 draws nothing rather than a broken image.

   ★ The icons carry their English title inside the artwork. That is what "the official icon"
   IS — every sustainability report on earth uses these exact tiles — so they are not translated
   and never redrawn. The readable label beside them is, which is why this only ever renders
   next to text and never on its own. */

export const sdgIconUrl = (number) => {
  const n = Number(number);
  return n >= 1 && n <= 17 ? `${process.env.PUBLIC_URL || ''}/sdg/${n}.png` : null;
};

const SdgIcon = ({ number, className = '', alt = '' }) => {
  const src = sdgIconUrl(number);
  if (!src) return null;
  return (
    <img
      src={src}
      className={`sdg-icon ${className}`}
      /* Decorative wherever the label is right there beside it — a screen reader that reads the
         goal's name twice is worse than one that reads it once. */
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
      loading="lazy"
    />
  );
};

export default SdgIcon;
